import React from 'react';
import classNames from 'classnames';
import styles from './field-label.scss';
export const FieldLabel = _ref => {
  let {
    required = false,
    label,
    hideLabel = false,
    hideAsterisk = false
  } = _ref;
  return /*#__PURE__*/React.createElement("span", {
    className: classNames(styles.label, {
      [styles.hidden]: hideLabel
    })
  }, label, required && !hideAsterisk && /*#__PURE__*/React.createElement("span", {
    className: styles.asteriskMargin,
    "aria-hidden": "true"
  }, "*"));
};
//# sourceMappingURL=field-label.js.map